var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`mm-progress-bar bg-${_vm.colorName}-light ${_vm.verticle ? 'progress-bar-vertical bg-'+_vm.colorName : '-light'}`},[_c('span',{ref:"progress",class:`bg-${_vm.color}`+' '+_vm.midclass,staticStyle:{"transition":"'width 2s ease 0s"},attrs:{"data-value":_vm.value}},[_vm._t("text")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }